import React from 'react';
import OrderList from '../common/OrderList';
import { estimatesAPI } from '../../services/api';
import { FilePlus2, ShoppingBag } from 'lucide-react';

export default function Estimates() {
  return (
    <OrderList
      title="Estimates"
      icon="📝"
      api={estimatesAPI}
      basePath="/estimates"
      statuses={['Draft', 'Sent', 'Accepted', 'Rejected', 'Converted', 'Closed']}
      numberField="estimate_number"
      partyField="customer_name"
      dateField="estimate_date"
      secondField="expiration_date"
      secondLabel="Expires"
      convertActions={[
        { label: 'Invoice', icon: <FilePlus2 size={12} />, handler: (id) => estimatesAPI.convertToInvoice(id), redirectTo: (invoiceId) => `/invoices/${invoiceId}` },
        { label: 'Sales Order', icon: <ShoppingBag size={12} />, handler: (id) => estimatesAPI.convertToSalesOrder(id), redirectTo: (soId) => `/sales-orders/${soId}/edit` },
      ]}
    />
  );
}
